<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<span id="Page_21" title="[21]"></span>
<h2 class="nobreak" id="pgepubid00003">II<br class="calibre17"/>
<span class="small">APRIL’S SON</span></h2>
</div>
<p class="calibre3"><span class="smcap">Taking</span> Maum Hannah’s three steps as one, he called
out a breathless greeting:</p>
<p class="calibre3">“How you do, Cun [Cousin] Hannah?”</p>
<p class="calibre3">She was stirring a pot on the hearth and the long
spoon clattered against the iron sides she dropped it.
“Who dat call me?” She limped backward a few
halting paces and gazed at him with questioning eyes.</p>
<p class="calibre3">“Dis is me, old man Breeze! Git you birthin’ beads
quick an’ come go home wid me!”</p>
<p class="calibre3">She stared at him vacantly. “Fo’ Gawd’s sake, who
is you?” She whispered sharply.</p>
<p class="calibre3">“You don’ know me? Is you gone blind, Hannah?”</p>
<p class="calibre3">Her arms dropped weakly as she peered at him,
taking in his bare feet, his patched clothes, his shirt,
open at the neck, showing the swell of his throat, the
panting of his breast. With a sudden burst of laughter
she reached out and took his hand. “Lawd, Breeze, I
thought sho’ you was Grampa’s sperit come fo’ me!
You scared me well-nigh to death, son! Come on een
an’ set down! Jedus, I’m glad to see you! But you is
de very spit o’ Grampa!”</p>
<p class="calibre3">“I can’ set, Hannah. I ain’ Grampa’s sperit, but I
sho’ did come to git you! My li’l’ gal is ’bout to die,
Hannah. E can’ birth e chile to save life, no matter
how hard e try. Git Gramma’s birthin’ beads. You
got to go wid me. I couldn’ stan’ to le’ dat li’l’ gal die,<span id="Page_22" title="[22]"></span>
an’ don’ do all I can to save em. E’s so pitiful in e
pain.”</p>
<p class="calibre3">Maum Hannah grunted. “Pain don’ kill a
’oman, son. It takes pain to make em work steady till
de task is done. I can’ stop no pain! No, Jedus! De
gal might be well by now anyhow.”</p>
<p class="calibre3">But he was firm. “Listen to me, Hannah! You got
to go home wid me to-night! Now! In a hurry! Make
haste, too!”</p>
<p class="calibre3">“It’s a mighty black night since de moon is gone
down.”</p>
<p class="calibre3">“Bein’ black don’ matter. I know de way. You
come on, Hannah.”</p>
<p class="calibre3">“I declare to Gawd, my cripple knee is so painful I
don’ know ef I could git in a boat.”</p>
<p class="calibre3">“Den I’ll tote you, but you sho’ got to come.”</p>
<p class="calibre3">“I’m mighty ’f’aid o’ boats an’ water in de daytime
much less at night.” She leaned down to fix the sticks
on the fire, but he caught her roughly by the arm.</p>
<p class="calibre3">“Don’ you tarry, Hannah. You come on right
now!”</p>
<p class="calibre3">“What kind o’ boat you got?”</p>
<p class="calibre3">“De boat’s narrow an’ de river’s high, but you got
strong heart, enty? You’ll be as safe wid me in dat
boat as ef you was settin’ right here by de fire in your
rockin’ chair. I promised my li’l’ gal to fetch you an’
you’ birthin’ beads ef e would hold out till I git back.
You better come on! Gramma’ll hant you sho’ as you
fail me to-night!”</p>
<p class="calibre3">Maum Hannah sighed deep. “I know I got to go,
scared as I is. A boat on a floodin’ river is a turrible
t’ing, but I sho’ don’ want Gramma’s sperit to git no
grudge against me. Catchin’ chillen is Jedus’ business
anyhow, an’ de river belongs to Jedus, same as me an’
you, I reckon. You wait till I git de beads out de<span id="Page_23" title="[23]"></span>
trunk. Sometimes I wish Gramma didn’ leave me dem
beads. It’s de truth!”</p>
<p class="calibre3">She groped her way to the shed-room and fumbled
in a trunk, then called out that she needed a light. He
broke a splinter off from a stick of fat lightwood on the
hearth and, lighting it, took it to her. The small flame
blazed up, sputtering and hissing, and spat black drops
of tar on the clean floor, on the quilt covered bed, on the
wide white apron she was tying around her waist. The
shaking hand that held it was to blame.</p>
<p class="calibre3">“How come you’ hand is a-tremblin’ so, Breeze?”
she asked gently. “You is pure shakin’ like a leaf.
Trust in Gawd, son. You’ gal b’longs to Him, not to
you. Jedus ain’ gwine fail em now when e have need.”</p>
<p class="calibre3">The light wavered wildly as he raised an arm to
draw his shirt-sleeve across his eyes. Big teardrops
rolled down his cheeks, and his face twitched dumbly.</p>
<p class="calibre3">“You mus’ scuse me, Hannah. I’m so weakened
down wid frettin’ until de water dreans out my eyes.
My mind keeps a runnin’ back to de time dis same li’l’
gal’s own mammy was taken dis same way. When de
tide turned, e went out wid em. Dat’s how come I’m
hurryin’ you so fas’. We mus’ git back whilst de tide
is risin’.”</p>
<p class="calibre3">He stood, straight and tall, and strong for his years,
but the troubled look in his eyes made the old midwife
wonder.</p>
<p class="calibre3">Her weight tilted the narrow boat so far to one side
that some of the black river water slid over its edge and
ran down cold on her feet. “Jedus hab mussy!” she
groaned. “If dis boat do go down, I’ll sho’ git drowned
to-night! I can’ swim, not a lick.”</p>
<p class="calibre3">“You set still, Hannah. Dis boat knows better’n to
turn over to-night. I got em trained. E’s got sense
like people. E knows e’s got to take me an’ you safe.”</p>
<p class="calibre3"><span id="Page_24" title="[24]"></span>“I’m mighty glad to hear dat, son, mighty glad.”</p>
<p class="calibre3">The boat was already gliding swiftly past the black
willows on the Blue Brook’s bank and around the bend
where the thick trees made shadows and long tresses of
gray moss waved overhead. Soon they’d reach the river.
When a dark bird flew across the stream Maum Hannah
shivered and whispered, “Do, Jedus, hab mussy,” but
Breeze muttered, “Dat ain’ nuttin’ but a summer
duck.”</p>
<p class="calibre3">The whole world lay still, wrapped by the night,
quiet, save for the swish of the water against the sides
of the boat as the noiseless dips of the steady-plying
paddle thrust it on.</p>
<p class="calibre3">As they neared Sandy Island the shrill cry of an owl
in the distance caused the boat to falter in its forward
going.</p>
<p class="calibre3">“Wha’ dat, Breeze?”</p>
<p class="calibre3">“Dat’s one o’ dem blue-dartin’ owls. Dat ain’ no
sign o’ death.”</p>
<p class="calibre3">Ripples from the boat broke into glittering sparkles
of light laid by the stars on the water. The river murmured.
Trees along the bank were full of strange
shadowy shapes. Whenever the lightest rustle of wind
drifted through the black branches, low smothered sobs
fell from them.</p>
<p class="calibre3">A tall sycamore with its white outstretched arms
high up toward heaven, reached toward the river waving,
beckoning.</p>
<p class="calibre3">The night air was cool, but Maum Hannah took up
the edge of her apron and wiped off big drops of sweat
that broke out cold as ice on her forehead. “Do, Jedus,
hab mussy!” she prayed.</p>
<p class="calibre3">The new moon had gone to bed. Now was the time
evil spirits walk and take people’s souls out of their
bodies. Pines on the island made soft moans. The<span id="Page_25" title="[25]"></span>
darkness quivered with whispers. Only the firelight
shining out from the cabin on the hill made a clear red
star to guide them.</p>
<p class="calibre3">The narrow boat swerved and turned in-shore.
A cypress knee, hidden by the water, bumped hard
against it, but didn’t stop its leap toward the bank. Old
Breeze eased himself past Maum Hannah, and hopping
out on the wet sand drew the boat up a little higher on
the hill.</p>
<p class="calibre3">“Git up, Hannah. Le’ me hold all two o’ you’ hands.
Step slow. Hist you’ foot. Don’ miss an’ trip. Now
you’s on dry land.”</p>
<p class="calibre3">“T’ank Gawd! Praise Jedus’ name!”</p>
<p class="calibre3">“You got de beads, enty?”</p>
<p class="calibre3">“Sho’ I got ’em. Dem beads is all de luck I got in
dis world. If dey was to git lost, I’d be ruint fo’ true.
Pure ruint!”</p>
<p class="calibre3">The steep climb cut her breath and stopped her flow
of talk, but Granny who had heard them coming, croaked
out:</p>
<p class="calibre3">“Yunnuh better make haste. De chile is done come,
but de gal won’ wake up an’ finish de job. Yunnuh
come on.”</p>
<p class="calibre3">Maum Hannah lifted the long dark string of beads
from around her neck and handed them to old Breeze.
“Run wid ’em, son. Put ’em round de gal’s neck.
Right on e naked skin. If I try to walk fast I might
fall down an’ broke my leg.”</p>
<p class="calibre3">Breath scarcely came and went through the girl’s
parted lips, and her teeth showed white. Were they
clenched? Old Breeze pressed on the round chin to see.
Thank God the mouth could open!</p>
<p class="calibre3">Maum Hannah got inside the room at last. The
charm words that went with the beads would set things
right. Death might as well go on home! Let the girl<span id="Page_26" title="[26]"></span>
rest. She was tired. Things could wait while she had
her nap out.</p>
<p class="calibre3">The big hickory armchair, drawn close to the fire,
held a feather pillow on its cowhide seat, and lying in
the nest it made was a small black human being.
Granny laughed as she picked it up and put it into
Maum Hannah’s hands, saying:</p>
<p class="calibre3">“A boy-chile! An’ born wid a caul on e face!”</p>
<p class="calibre3">“Great Gawd, what is dis! You hear dis news,
Breeze? Dis chile was born wid a caul on e face!”</p>
<p class="calibre3">The man turned his troubled eyes away from the
bed. “Wha’ you say, Hannah?”</p>
<p class="calibre3">Laughing with pleasure Maum Hannah and Granny
both told him again. His grandson had been blessed
with second-sight. He had been born on the small of
the moon and with a caul over his face. He would have
second sight. He’d always be able to see things that stay
hidden from other people. Hants and spirits and plat-eyes
and ghosts. Things to come and things long gone
would all walk clear before him. They couldn’t hide
from this child’s eyes.</p>
<p class="calibre3">“Hotten another pot o’ water, Granny. Lemme
warm em good, an’ make em cry.” Maum Hannah
cradled the child tenderly in her hands, then held him
low so the firelight could shine in his face. With a quick
laugh she caught him by one foot and holding him
upside down smacked him sharply with three brisk slaps.</p>
<p class="calibre3">“Cry, suh!” she scolded. “Ketch air an’ holler! I
hate to lick you so hard soon as you git here, but I got
to make you fret out loud.” A poor weak bleating
sounded and she handed the child to Granny.</p>
<p class="calibre3">“You fix em, whilst I finish up wid de mammy.”</p>
<p class="calibre3">“Wake up, gal!” she plead, shaking the girl’s limp
arm. “Wake up!”</p>
<p class="calibre3"><span id="Page_27" title="[27]"></span>The rigid eyelids fluttered open and a faint smile
played over the girl’s face. She was too weary to draw
her breath. The pain had sapped all her strength, every
bit.</p>
<p class="calibre3">Maum Hannah stooped and looked under the bed.</p>
<p class="calibre3">“Great Gawd,” she grunted. “Who dat put a’ ax
under dis bed? No wonder de pains quit altogedder.
You ought to had chunked dese irons out de door!” She
did it forthwith herself.</p>
<p class="calibre3">“Now! All two is gone! Open you’ eyes, gal!
Ketch a long breat. Dat’s de way. Hol’ you’ two hands
togedder. So. Blow in ’em! Hard. Hard as you
kin! Make a stiff win’ wid you’ mouth! Blow you’
fingers off. Dat’s de way!”</p>
<p class="calibre3">Then something else went wrong. Where was a
spider’s web? Granny ought to have had one ready.
Every good midwife should find one as soon as she takes
a case. Maum Hannah’s eyes were too dim to see a web
on the dark rafters overhead. Somebody must find one
and fetch it quickly. Life can leak out fast. Spider webs
can dam it up better than anything else. But,
lord, they are hard to find at night! Where was Breeze?</p>
<p class="calibre3">One was found at last. Then it took careful handling
to get it well covered with clean soot from the back of
the chimney. Thank God for those beads. The girl
would have lost heart and given up except for them and
the charm words which Maum Hannah kept saying over
and over. With those beads working, things had to
come right. Had to. And they could not help working.
Couldn’t, thank God.</p>
<p class="calibre3">The next morning’s sunshine showed plenty of gossamer
webs spun with shining wheels. Long threads of
frail silk were strung across the yard from bush to bush,
traps set by the spiders for gnats and mosquitoes, strong<span id="Page_28" title="[28]"></span>
enough to hold a fly once in a while. But it takes a
house spider’s stout close-woven web to hold soot and do
good. For a house spider to make its home under your
roof is good luck, for sooner or later the cloth it weaves
and spins will save somebody’s life.</p>
<p class="calibre3">Old Breeze got up early and cooked the breakfast,
fixed himself a bit to eat and a swallow or two of sweetened
water to drink and went to the field to work, but
the two old women sat by the fire and nodded until the
sun waxed warm and its yellow light glowed into the
room through the wide-open door. Then their tired old
bodies livened and their heads raised up and leaned
together while whispered talk crept back and forth
between them. Granny held that Breeze was a good
kind man to take the girl’s trouble as he did. Many a
man would have put her out-of-doors. Girls are mighty
wild and careless these days. But their parents are to
blame for it too. Half the children born on Sandy
Island were unfathered. It wasn’t right. Yet how can
you stop them? Maum Hannah sighed and shook her
head. It was a pity. And yet, after all, every child
comes into the world by the same old road.</p>
<p class="calibre3">A thousand husbands couldn’t make that journey
one whit easier. The preachers say God made the
birthing pain tough when He got vexed with Eve in the
Garden of Eden. He wanted all women to know how
heavy His hand can be. Yet Eve had a lawful husband,
and did that help her any?</p>
<p class="calibre3">Granny blinked at the fire and studied a while, then
with a sly look at the bed she whispered that this same
little boy-child was got right yonder at Blue Brook during
the protracted meeting last summer. Her wizened
face showed she knew more than she cared to tell. Not
that it was anything to her whose child it was.</p>
<p class="calibre3">She fidgeted with her tin cup and spoon and peeped<span id="Page_29" title="[29]"></span>
at Maum Hannah out of the corner of her eye, then
asked with pretended indifference:</p>
<p class="calibre3">“What’s de name o’ de gentleman what’s de foreman
at Blue Brook now?”</p>
<p class="calibre3">“E’s name April.”</p>
<p class="calibre3">“Enty?” Granny affected surprise. “Is e got a
fambly?” she presently ventured in spite of Maum
Hannah’s shut-mouthed manner.</p>
<p class="calibre3">“Sho’, e’s got a fambly. E’s got a fine wife an’ a
house full o’ chillen too.”</p>
<p class="calibre3">“Well, I declare!” Granny mirated pleasantly.
“Was any o’ dem born wid a caul?”</p>
<p class="calibre3">“No, dey wasn’t. I never did hear o’ but one or
two people bein’ born wid a caul. Ol’ Uncle Isaac,
yonder to Blue Brook is one, and e’s de best conjure
doctor I ever seen.”</p>
<p class="calibre3">“Who was de other one?” Granny inquired so
mildly that Maum Hannah stole a look at her hard, dried
furrowed face. There was no use to beat about the bush
with Granny, so she answered:</p>
<p class="calibre3">“April, de foreman at Blue Brook, was de other one.
Dese same ol’ hands o’ mine caught April when e come
into dis world, just like deys caught all o’ April’s
chillen.”</p>
<p class="calibre3">“You mean, April’s yard chillen, enty?” Granny
looked her straight in the eyes like a hawk, but Maum
Hannah met the look calmly, without any sign of annoyance.</p>
<p class="calibre3">“I dunno what you’s aimin’ at, Granny. April’s a
fine man. Blue Brook never did have no better foreman.
An’ his mammy, Katy, was one o’ de best women ever
lived. April was she onliest child. April was born dis
same month. Dat’s how come Katy named him April.
April’s a lucky month an’ a lucky name, too. Wha’ you
gwine name you li’l’ boy-chile, daughter?”</p>
<p class="calibre3"><span id="Page_30" title="[30]"></span>Granny looked toward the bed and listened for the
answer.</p>
<p class="calibre3">“I dunno, ma’am,” the girl answered weakly, and
Granny sweetened her coffee with a few drops more of
molasses. She stirred and stirred until Maum Hannah
suggested:</p>
<p class="calibre3">“April’s a fine name. Whyn’t you name em dat?
When I git back to Blue Brook, I’ll tell de foreman I
named a li’l’ boy-chile at him. Dat would please em
too. E might would send em a present. April’s a
mighty free-handed man, an’ e sho’ thinks de world
o’ me too.”</p>
<p class="calibre3">Granny waited to taste the sweetened coffee until she
heard what the girl said. The girl didn’t make any
answer at first, but presently she said with a sorrowful
sigh, she’d have to think about the baby’s name. She
couldn’t decide in a hurry. Sometimes a wrong name
will even kill a baby. She must go slow and choose a
name that was certain to bring her baby health and luck.</p>
<p class="calibre3">She talked it over with her father and named the
baby Breeze, for him. No foreman in the world was a
finer man, or a kinder, stronger, wiser one. The breeze
for which he was named could have been no pleasanter,
no sweeter, than the breeze that blew in from the river
that very morning.</p>
<p class="calibre3">The old man beamed with pleasure. He was glad to
have the child named for him. But since the month
was April, why not name him April Breeze? Then he’d
have two good-luck names, and two would be better
than one.</p>
<p class="calibre3">“We could call em li’l’ Breeze, enty?” she asked
with a catch in her voice.</p>
<p class="calibre3">“Sho’, honey! Sho’! If dat’s de name you choose
to call dis chile, den e’s li’l’ Breeze f’om now on. But
April is a mighty nice name for a boy-chile.”</p>
<p class="calibre3"><span id="Page_31" title="[31]"></span>“It’s de Gawd’s truth,” Maum Hannah declared,
and Granny grunted and reached for a coal to light her
pipe.</p>
<p class="calibre3">Li’l’ Breeze grew and throve and his grandfather
prized him above everything, everybody else. He was a
boy-child, and, besides, he was born with a caul on his
face. Men born so make their mark in this world. Rule
their fellows. Plenty of people have no fathers, and
many of them are better off. A child that has never
looked on his daddy’s face can cure sickness better than
any medicine. Just with a touch of the hand, too. It
was a good thing for Sandy Island to have such a child.</p>
<p class="calibre3">Before Breeze was weaned people began coming to
have him stroke the pain out of their knees and backs
and shoulders. He could cure thrash in babies’ mouths,
and even cool fevers.</p>
<p class="calibre3">His mother’s disgrace was completely forgotten, when
she married a fine-looking, stylish young town man who
came to Sandy Island to preach and form a Bury League.
He could read both reading and writing and
talk as well as the preacher who read over them out of
a book.</p>
<p class="calibre3">Breeze stayed on with his grandfather, helping him
farm in the summer and set nets for shad in the spring.
When the white people who owned Sandy Island came
from somewhere up-North in the winter and crossed over
the river on a ferry-flat from Blue Brook with their dogs
and horses to hunt the deer that swarm so thick on the
island that they have beaten paths the same as pigs and
rabbits, Breeze went along to help hold the horses and
watch the dogs. People said he was Old Breeze’s heart-string,
and Old Breeze’s eyeball. He was, although the
mother had other boy-children now, fine ones too.</p>
<p class="calibre3">And instead of the grandfather’s getting feeble and
tottering with age, he grew younger, and worked harder,<span id="Page_32" title="[32]"></span>
so that he and Breeze might have plenty. Every extra
cent saved was buried at the foot of a tall pine tree
growing on the bank of the river not far from the cabin’s
front door. When hard times came, they’d have no
lack. The money would be there, secretly waiting to be
spent.</p>
<p class="calibre3">One spring when the shad fishing was done, Old
Breeze got leave from the white folks to cut down some
dead pines the beetles had killed. He dragged these
to the river with his two old oxen, and made them into a
raft which he floated down to the town in the river’s
mouth, and sold to a big saw-mill there. Breeze stayed
with his mother until his grandfather came back home,
pleased as could be, with presents for everybody, and a
pocket full of money besides. But although he brought
the mother a Bible besides many other fine things that
made her smile, she shook her head and said, “Dead
trees are best left alone. Trees have spirits the same
as men. God made them to stand up after they die.
Better let them be.”</p>
<p class="calibre3">But the grandfather was not afraid of tree spirits,
and he cut and cut until no dead tree was left standing
and the ground all around the big pine tree was full of
hidden money. Then there was nothing to do but fish
and hunt, and to hunt in the spring is against the white
men’s laws. Old Breeze got restless. He gazed in the
fire night after night, thinking and thinking.</p>
<p class="calibre3">One morning he got up early and skimmed all the
cream and put the clabber in a jug, then he took the
brace-and-bit down off the joist where it stayed and
walked off to the woods alone. Every morning he did it.
There was no more clabber for the pigs or the chickens,
but the pine trees began dying so fast that before long
enough were ready to cut for a raft to be floated down
the river.</p>
<p class="calibre3"><span id="Page_33" title="[33]"></span>The tall pine close to the bank was the biggest tree
on Sandy Island. It stretched far above the oaks before
it put on even one limb. If that tree ever died, it would
make a good part of a raft by itself.</p>
<p class="calibre3">One cold dark dawn, Breeze was roused by the
cabin’s door creaking on its hinges as it closed behind
somebody’s muffled steps. Where was Old Breeze going?
Easing a window open, he peered out and saw the old
man going toward the big pine with the jug and the
brace-and-bit.</p>
<p class="calibre3">“Wait on me! I’m a-gwine wid you!” he called.</p>
<p class="calibre3">Old Breeze stopped and stood stiffly erect.</p>
<p class="calibre3">“Who dat call me?”</p>
<p class="calibre3">“Dis me! Breeze!”</p>
<p class="calibre3">The old man broke into a laugh. “Lawd, son, I
thought sho’ a sperit was a-talkin’ to me. How come
you’s ’wake so soon? Git back in de bed an’ sleep!”</p>
<p class="calibre3">But Breeze dressed in a hurry. He wanted to see
what would be done with clabber and the brace-and-bit.</p>
<p class="calibre3">Outside in the half-light it was silent except for the
rustle of the big tree’s needles in the wind. Breeze
watched while holes were bored deep in the solid roots
and the clabber all poured down them. He promised
never to tell a soul. Not a soul. That was a stubborn
tree. It swallowed down many a jug of buttermilk and
clabber without getting sick at all, but at last the tips of
its needles looked pale. The green of them faded into
yellow, then brown, and its whole top withered. The
old tree gave up. Poor thing.</p>
<p class="calibre3">Its heaviest limbs faced the south, away from the
water. That was good. When it fell, the big butt cut,
the heaviest one, would be easy to roll into the river,
and the next two cuts would not have to be pushed very
far. That tree would bring money with its stout, fat
heart. A pocket full of money.</p>
<p class="calibre3"><span id="Page_34" title="[34]"></span>Sunday night came, and Old Breeze wouldn’t go to
meeting, but went to bed for a long night’s sleep. He
must get up a high head of strength before sunrise to
cut the big tree down.</p>
<p class="calibre3">Day was just breaking through the cracks of the
cabin’s log sides when Breeze heard it fall. It gave a
great cry, and its crash jarred the cabin. The weight
of a big tree’s falling always leaves a deep stillness
behind it, but after the big pine fell the stillness stayed
on. Breeze lay quiet and listened. The tree must have
dropped wrong, and gone across a clump of bamboo
vines. Old Breeze would have to clear them away before
his ax could begin to talk.</p>
<p class="calibre3">He’d hear it soon. Lord! Nobody could make an
ax speak faster or louder or truer. Nobody. This was
Monday morning and he must get the clothes up for
the mother to wash. Every Monday he carried them to
her and helped her do the washing.</p>
<p class="calibre3">Kingfishers splashed into the river. Once an eagle
cried. The day moved on, smooth and bright and
yellow, as the sun walked up the sky past the tree-tops,
higher and higher until noon stood overhead. But the
grandfather’s ax had said nothing yet. Not yet. But
wait! It would make up for lost time when it started to
ring!</p>
<p class="calibre3">Sis, the stepfather’s young sister, lived with Breeze’s
mother and helped her mind the children. Every Monday
morning they washed the clothes out in the yard,
where the washtubs always sat on a bench in a sunshiny
place. The other children, Breeze’s half brothers and
sisters, roasted sweet potatoes in the ashes under the big
black washpot, and kept the fire going.</p>
<p class="calibre3">On that Monday morning, the fire burned blue and
kept popping, and every now and then the mother cast
her eyes, full of dark thoughts, at the sun. Old Breeze<span id="Page_35" title="[35]"></span>
always came for dinner with her on Monday. Something
must have happened. The big tree must have fallen
wrong to keep him so long. But Sis could talk of nothing
but the new dress and the ribbon he had promised
to buy her with some of the money the big pine brought.</p>
<p class="calibre3">The mother lifted the lids of the little pots that sat
all around the big washpot cooking the family’s dinner.
With a big iron spoon she stirred and tasted, added salt
and a pod of red pepper. Pepper is good to help men be
strong and warm-hearted. It makes hens lay, too. She
filled the bucket with victuals and told Breeze to run,
fast as he could, to the big tree, so the dinner would be
hot when he got there. Hopping John, peas and rice
cooked together, is so much better fresh out of the pot
and breathing out steam. When rice cools it gets
gummy. The fish stew was made out of eels, and they
get raw again as soon as the fire’s heat leaves them.
Breeze must take his foot in his hand and fly.</p>
<p class="calibre3">Breeze did run, but he soon came running back, for
Old Breeze wasn’t there. His ax lay almost in the
water, with its handle wet, and his throwing-wedge
beside it.</p>
<p class="calibre3">The two old oxen were chewing their cuds, but the
ground around the tree was all dug up and broken, as
if hogs had rooted it up to find worms.</p>
<p class="calibre3">Breeze had called, and called, but nobody answered!
When the mother heard that, a shiver went clear
through her body. Her hands shook so when she lifted
them out of the washtub that all the soap-suds on them
trembled.</p>
<p class="calibre3">She said she’d go and call. She knew how to send
her voice far away. She could make him hear and
answer. Maybe a deer or a fox or a wildcat had come
and tricked him away from his work, but her words
quivered in her mouth as she said them.</p>
<p class="calibre3"><span id="Page_36" title="[36]"></span>All the children went trailing after her; Sis
went hurrying with baby Sonny in her arms; and they
all stood still and listened while the mother’s throat sent
long thin whoopees away up into the sky. Her breast
heaved with hoisting them so far above the trees into
the far-away distance. She’d wait for an answer until
all the echoes had whooped back, then she’d take a deep
breath and cry out again.</p>
<p class="calibre3">An old crow laughed as he passed overhead, an owl
who-whooed far in the distance. The wind began moaning
and crying in the tops of all the other trees around
the fallen pine.</p>
<p class="calibre3">The mother dropped on her knees and laid her forehead
down on the earth. Her thin body shook, and her
fingers twisted in and out as her hands wrung each other
almost to breaking. She prayed and moaned and begged
Jesus to call Granddad to come back. To come on in a
hurry. She couldn’t stand for him not to answer when
she called so hard and so long.</p>
<p class="calibre3">All the children began crying with her. Even Sis,
who never cried no matter what happened, put Sonny
down on the naked ground and with tears running out
of her eyes all over her face, reached out and took the
mother’s shoulders in both arms. She tried to keep
them from shaking, but she soon shook with them, for
the mother said over and over she had known all the
time that something bad was going to happen. She
knew it last night when she came home from meeting.
Her fine glass lamp-shade, the one Granddad brought
her from town, with flowers on it, broke right in two in
her hand. She hadn’t dropped it, or knocked it against
anything, but it broke in two in her hand. Her moaning
talk changed to a kind of singing as her body rocked
from side to side. Her face turned up to the sky, her
eyes gazed straight at the sun, and over and over she<span id="Page_37" title="[37]"></span>
wailed the same words until the littlest children all cried
out and screamed them too:</p>
<div class="poetry-container">
<div class="poetry">
<div class="first">“Las night I been know</div>
<div class="verse">Somebody gwine dead!</div>
<div class="verse">Yes, Lawd! Somebody gwine dead!</div>
<div class="verse">A sign sesso!</div>
<div class="verse">Yes, Lawd, a sign sesso!</div>
<div class="verse">De hoot-owl ain’ talk!</div>
<div class="verse">De wind ain’ whine!</div>
<div class="verse">I ain’ see a ground-crack needer!</div>
<div class="verse">But I had a sign,</div>
<div class="verse">Jedus gi’ me a sign!</div>
<div class="verse">Da lamp-shade!</div>
<div class="verse">F’om de town-sto!</div>
<div class="verse">E come een two</div>
<div class="verse">Een my hand!</div>
<div class="verse">Yes, Lawd!</div>
<div class="verse">E come een two een my hand!</div>
<div class="verse">I ain’ drap em. No!</div>
<div class="verse">I ain’ knock em against nuttin,</div>
<div class="verse">But e come een two</div>
<div class="verse">Een my hand!</div>
<div class="verse">De lamp-shade know,</div>
<div class="verse">E try fo’ talk,</div>
<div class="verse">E broke fo’ gi’ me a sign.</div>
<div class="verse">My Pa is dead!</div>
<div class="verse">I know, fo’ sho’!</div>
<div class="verse">Da lamp-shade broke</div>
<div class="verse">Een my hand!”</div>
</div>
</div>
<p class="calibre3">Her breath caught in her throat with gasps and her
grieving got hoarse and husky, the steady sing-song
braced by the children’s shrill mourning reached the
neighbors who came hurrying to see what was wrong.</p>
<p class="calibre3">At first they tried to cheer up the mother’s heart
with big-sounding, bantering talk. Granddad could<span id="Page_38" title="[38]"></span>
outswim an otter. The river could drown him no more
than a duck. He had followed a wild turkey, or a hog
going to make her bed. It was wrong to trouble trouble
before trouble troubles you. Hogs had rooted up the
earth around the pine. Nobody had done that. Granny
hobbled up, muttering to herself between her toothless
jaws. The sun shone right into her eyes and marked
how they shifted sly looks from the fallen tree to the
earth. Her withered fingers plucked at the dirty greasy
charm thread around her wrist. One bony finger
pointed at the broken ground.</p>
<p class="calibre3">“Whe’ is e, Granny?” the mother asked, and the
silence was that of a grave. Granny’s palsied head
shook harder than ever, and the mother rent the air
with her cries. Sis and the children joined in with
wails, and the dogs all howled and barked. Granny said
Old Breeze was done for! The same as the felled tree.
Who was to blame? How could she tell? Had he eaten
any strange victuals lately? Had he drunk water out of
any strange well? No? Then he must have been tricked
by somebody under his roof. Somebody who wished him
ill had put an evil eye on him. No strong well man would
melt away unless he had been bewitched. Granny
peeped sidewise at Breeze. Where was his stepfather?
Where? Nobody answered the old woman, but feet
shuffled uneasily as she said that the whole of Sandy
Island showed signs of bewitchment. When had it
rained? The fowls’ eggs hatched poorly. The cows lost
their cuds. The fish didn’t bite. Shooting stars kept
the sky bright every night. Black works were the cause!
Then everybody chimed in; it must be as Granny said.
And the old woman looked straight at Breeze. He was
born with second-sight. The young moon was here. This
was the time when all those who are cheated out of life
come back and walk on this earth whenever a young
moon shines. If Old Breeze had met with foul death,<span id="Page_39" title="[39]"></span>
he’d come back that night and walk around that very
pine as soon as the first dark came. Young Breeze must
watch for him and talk with him and find out what had
happened to him. Nobody else on Sandy Island could
talk to spirits like that boy. He had been born with a
caul over his face, and that strange thing that had veiled
his eyes when he came into the world gave them the
power to see things other people could never witness.
Spirits and hants and ghosts and plat-eyes.</p>
<p class="calibre3">Granny’s talk made Breeze’s flesh creep cold on his
bones. His blood stopped running. Fear tried to put
wings on his feet, but he clung to his mother’s skirt and
wept, for even the shadows began an uncertain flickering
and wavering as if they’d reach out and grab him.</p>
<p class="calibre3">“Hogs ain’ rooted up de ground. Not no hogs what
walks on fo’ legs. No. Sperits might ’a’ done it—but
whe’s you’ husban’, gal? Whe’ e is?”</p>
<p class="calibre3">Nobody knew. Nobody ever knew. And Breeze was
too coward-hearted to watch for his grandfather’s spirit.
No matter how Granny scolded him, he couldn’t do it.</p>
<p class="calibre3">Days afterward, April, the foreman on Blue Brook
Plantation, came to Sandy Island, bringing a pair of
blue overalls holding pieces of a man. He had fished
them up out of the Blue Brook itself where they had
drifted instead of going on down to the river’s mouth.</p>
<p class="calibre3">Old Breeze had worn blue overalls that Monday
morning. Maybe it was he. More than likely it was he.
Granny was certain of it.</p>
<p class="calibre3">The stepfather had disappeared with the money
buried at the foot of the old dead pine, but April stayed
to help dig a grave and bury the poor thing he had
found. The mother shrieked and wailed, but Granny
grunted and shook her head. She said Old Breeze’s body
floated to Blue Brook on purpose so April could find it,
for April was Old Breeze’s son, and, more than that,
April was li’l’ Breeze’s daddy!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?7d88a390